import Icon from '../../components/Icon.vue'

Icon.register({
  'brands/sistrix': {
    width: 448,
    height: 512,
    paths: [
      {
        d: 'M448 449L301.2 300.2C321.2 272.3 333.1 238 333.1 201 333.1 107.9 258.4 32.1 166.6 32.1 74.7 32 0 107.8 0 200.9S74.7 369.8 166.5 369.8C206.3 369.8 242.8 355.6 271.5 331.9L417.5 480 448 449zM166.5 330.8C95.9 330.8 38.4 272.5 38.4 200.9S95.9 71 166.5 71 294.6 129.3 294.6 200.9 237.2 330.8 166.5 330.8z'
      }
    ]
  }
})



//////////////////
// WEBPACK FOOTER
// ./~/vue-awesome/icons/brands/sistrix.js
// module id = ypur
// module chunks = 144